module.exports = __webpack_public_path__ + "img/AVAX.31cd7407.svg";